import { faker } from '@faker-js/faker';
import type { EncashResponse } from 'types';
import { signInMock } from './auth';
import { devices } from './devices';

const DAYS = 30;

export const encashes = {
  Items: faker.helpers
    .uniqueArray(() => {
      const device = faker.helpers.arrayElement(devices);
      return {
        Id: faker.string.nanoid(),
        UserId: signInMock.User.Id,
        DeviceId: device.Id,
        Dts: +faker.date.recent({ days: DAYS }),
        DeviceTimestamp: +faker.date.recent({ days: DAYS }),
        Banknotes: DAYS * (device.DeviceState.DailySales.Sum.Banknotes ?? 0),
        Coins: DAYS * (device.DeviceState.DailySales.Sum.Coins ?? 0),
        Address: device.Info.Address
      };
    }, 3)
    .sort((a, b) => a.DeviceTimestamp - b.DeviceTimestamp),
  Count: 3,
  Username: signInMock.User.Username,
  Currency: {
    Code: 'RUB',
    Sign: '₽'
  }
} satisfies EncashResponse;

export const sum = {
  Banknotes: encashes.Items.reduce((acc, item) => acc + item.Banknotes, 0),
  Coins: encashes.Items.reduce((acc, item) => acc + item.Coins, 0),
  Currency: { Code: 'RUB', Sign: '₽' }
};
